import React from 'react';
import {
    HeaderContainer,
    ReservationsText,
    BottomWrapper,
    IconWrapper,
    Count,
    PercentageBar,
    GrowthTag,
    CardContainer
} from './ProgressBar.styles';

const ProgressBar = ({ title = "Reservations", count = 0, growth = "", percentage = 0, icon }) => {
    return (
        <CardContainer>
            <HeaderContainer>
                <ReservationsText>{title}</ReservationsText>
                <IconWrapper icon={icon} />
            </HeaderContainer>
            <BottomWrapper>
                <Count>{count}</Count>
                <GrowthTag>{growth}</GrowthTag>
            </BottomWrapper>
            {/* <PercentageBar>
                <div style={{ width: `${Math.min(percentage, 100)}%` }} className="filled"></div>
            </PercentageBar> */}
        </CardContainer>
    );
};

export default ProgressBar;
